module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-394.87ad234.woff2";